<template>
  <div>
    {{ _T_DB(address, 'name') }}, {{ _T_DB(address, 'address') }},
    {{ _T_DB(address, 'city') }}, {{ _T_DB(address, 'country') }}
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RestaurantAddress',
  props: { address: Object },
  computed: {
    ...mapGetters(['deliveryAreaName', '_T_DB']),
  },
}
</script>
